export default __webpack_public_path__ + "static/media/app-store.fd1e58b0.svg";